import React from 'react'

interface CardProps {
  variant:
    | 'regular'
    | 'plum'
    | 'topPicks'
    | 'modal'
    | 'linkCollectionPrimary'
    | 'linkCollectionSecondary'
}

const Card: React.FC<CardProps> = (props) => {
  const { variant, children } = props

  const cardClass = `Card Card__${variant}`
  return <div className={cardClass}>{children}</div>
}

export default Card
